const appHost = import.meta.env.VITE_APP_HOST || "http://localhost:3003"
const apiHost = import.meta.env.VITE_API_HOST || "http://localhost:3000"
const webSocketHost = import.meta.env.VITE_WEBSOCKET_HOST || "ws://localhost:3000"
const oauthAppPath = `${apiHost}/auth`
const sentryDsn = process.env.NODE_ENV === "production" ? import.meta.env.VITE_SENTRY_DSN || "" : ""

export { appHost, apiHost, oauthAppPath, webSocketHost, sentryDsn }
